import apiClient from '../../../services/apiClient';
import { exportData } from '../../../utils/exportData';
import { showErrorToast, showSuccessToast } from '../../../utils/toastHelper';

const ApiClient = async (method, route, data = {}) => {
  try {
    const prefixedRoute = '/master' + route;
    let response;
    if (method === 'post') {
      response = await apiClient.post(prefixedRoute, data);
    } else if (method === 'get') {
      response = await apiClient.get(prefixedRoute, { params: data });
    } else if (method === 'put') {
      response = await apiClient.put(prefixedRoute, data);
    } else if (method === 'delete') {
      response = await apiClient.delete(prefixedRoute);
    }
    console.log('data', response);
    return response.data;
  } catch (error) {
    console.log('error', error);
    showErrorToast(error?.message || 'An unexpected error occurred.');
    return error;
  }
};
export const importMasterData = async (formData) => {
  return await importData('/master/import', formData);
};
export const importData = async (route, formData) => {
  try {
    const response = await apiClient.post(route, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    console.log('data', response);

    showSuccessToast(response?.data?.message || '');
    return response.data;
  } catch (error) {
    console.log('error', error);
    showErrorToast(error?.message || 'An unexpected error occurred.');
    return error.data;
  }
};
export const addCustomerCateogry = async (data) => {
  return await ApiClient('post', '/customer-category', data);
};
export const fetchCustomerCateogries = async (query) => {
  return await ApiClient('get', '/customer-category', query);
};
export const updateCustomerCateogry = async (data, id) => {
  return await ApiClient('put', '/customer-category/' + id, data);
};

export const deleteCustomerCateogry = async (id) => {
  return await ApiClient('delete', '/customer-category/' + id);
};

// Area
export const addArea = async (data) => {
  return await ApiClient('post', '/area', data);
};

export const fetchAreas = async (query) => {
  return await ApiClient('get', '/area', query);
};

export const updateArea = async (data, id) => {
  return await ApiClient('put', '/area/' + id, data);
};

export const deleteArea = async (id) => {
  return await ApiClient('delete', '/area/' + id);
};

// District
export const addDistrict = async (data) => {
  return await ApiClient('post', '/district', data);
};

export const fetchDistricts = async (query) => {
  return await ApiClient('get', '/district', query);
};

export const updateDistrict = async (data, id) => {
  return await ApiClient('put', '/district/' + id, data);
};

export const deleteDistrict = async (id) => {
  return await ApiClient('delete', '/district/' + id);
};

// Logistic Line
export const addLogisticLine = async (data) => {
  return await ApiClient('post', '/logistic-line', data);
};

export const fetchLogisticLines = async (query) => {
  return await ApiClient('get', '/logistic-line', query);
};

export const updateLogisticLine = async (data, id) => {
  return await ApiClient('put', '/logistic-line/' + id, data);
};

export const deleteLogisticLine = async (id) => {
  return await ApiClient('delete', '/logistic-line/' + id);
};

// Payment Method
export const addPaymentMethod = async (data) => {
  return await ApiClient('post', '/payment-method', data);
};

export const fetchPaymentMethods = async (query) => {
  return await ApiClient('get', '/payment-method', query);
};

export const updatePaymentMethod = async (data, id) => {
  return await ApiClient('put', '/payment-method/' + id, data);
};

export const deletePaymentMethod = async (id) => {
  return await ApiClient('delete', '/payment-method/' + id);
};

// Process Category
export const addProcessCategory = async (data) => {
  return await ApiClient('post', '/process-category', data);
};

export const fetchProcessCategories = async (query) => {
  return await ApiClient('get', '/process-category', query);
};

export const updateProcessCategory = async (data, id) => {
  return await ApiClient('put', '/process-category/' + id, data);
};

export const deleteProcessCategory = async (id) => {
  return await ApiClient('delete', '/process-category/' + id);
};

// Product Category
export const addProductCategory = async (data) => {
  return await ApiClient('post', '/product-category', data);
};

export const fetchProductCategories = async (query) => {
  return await ApiClient('get', '/product-category', query);
};

export const updateProductCategory = async (data, id) => {
  return await ApiClient('put', '/product-category/' + id, data);
};

export const deleteProductCategory = async (id) => {
  return await ApiClient('delete', '/product-category/' + id);
};

// Origin
export const addOrigin = async (data) => {
  return await ApiClient('post', '/origin', data);
};

export const fetchOrigins = async (query) => {
  return await ApiClient('get', '/origin', query);
};

export const updateOrigin = async (data, id) => {
  return await ApiClient('put', '/origin/' + id, data);
};

export const deleteOrigin = async (id) => {
  return await ApiClient('delete', '/origin/' + id);
};

// Specification Value
// export const addSpecificationValue = async (data) => {
//   return await ApiClient("post", "/specification-value", data);
// };

// export const fetchSpecificationValues = async (query) => {
//   return await ApiClient("get", "/specification-value", query);
// };

// export const updateSpecificationValue = async (data, id) => {
//   return await ApiClient("put", "/specification-value/" + id, data);
// };

// export deleteupdateSpecificationValue = async (id) => {
//   return await Adeletelient("put", "/specification-value/" + id);
// };
// Specification Value
export const addProductUnit = async (data) => {
  return await ApiClient('post', '/product-unit', data);
};

export const fetchProductUnits = async (query) => {
  return await ApiClient('get', '/product-unit', query);
};

export const updateProductUnit = async (data, id) => {
  return await ApiClient('put', '/product-unit/' + id, data);
};

export const deleteProductUnit = async (id) => {
  return await ApiClient('delete', '/product-unit/' + id);
};

// Specification Unit
export const addSpecificationUnit = async (data) => {
  return await ApiClient('post', '/specification-unit', data);
};

export const fetchSpecificationUnits = async (query) => {
  return await ApiClient('get', '/specification-unit', query);
};

export const updateSpecificationUnit = async (data, id) => {
  return await ApiClient('put', '/specification-unit/' + id, data);
};

export const deleteSpecificationUnit = async (id) => {
  return await ApiClient('delete', '/specification-unit/' + id);
};

// Process Location
export const addProcessLocation = async (data) => {
  return await ApiClient('post', '/process-location', data);
};

export const fetchProcessLocations = async (query) => {
  return await ApiClient('get', '/process-location', query);
};

export const updateProcessLocation = async (data, id) => {
  return await ApiClient('put', '/process-location/' + id, data);
};

export const deleteProcessLocation = async (id) => {
  return await ApiClient('delete', '/process-location/' + id);
};

// Order Status
export const addOrderStatus = async (data) => {
  return await ApiClient('post', '/order-status', data);
};

export const fetchOrderStatuses = async (query) => {
  return await ApiClient('get', '/order-status', query);
};

export const updateOrderStatus = async (data, id) => {
  return await ApiClient('put', '/order-status/' + id, data);
};

export const deleteOrderStatus = async (id) => {
  return await ApiClient('delete', '/order-status/' + id);
};

// Delivery Status
export const addDeliveryStatus = async (data) => {
  return await ApiClient('post', '/delivery-status', data);
};

export const fetchDeliveryStatuses = async (query) => {
  return await ApiClient('get', '/delivery-status', query);
};

export const updateDeliveryStatus = async (data, id) => {
  return await ApiClient('put', '/delivery-status/' + id, data);
};

export const deleteDeliveryStatus = async (id) => {
  return await ApiClient('delete', '/delivery-status/' + id);
};
// Payment Status
export const addPaymentStatus = async (data) => {
  return await ApiClient('post', '/payment-status', data);
};

export const fetchPaymentStatuses = async (query) => {
  return await ApiClient('get', '/payment-status', query);
};

export const updatePaymentStatus = async (data, id) => {
  return await ApiClient('put', '/payment-status/' + id, data);
};

export const deletePaymentStatus = async (id) => {
  return await ApiClient('delete', '/payment-status/' + id);
};

export const exportMasterData = async (filters, fileName) => {
  return await exportData('/master/export', filters, fileName);
};
